import IMask from 'imask'

// Маска телефона с динамическим выбором формата:
//  • ввод, начинающийся с 7 или 8  → строгая российская маска +7 (___) ___-__-__
//    (Казахстан тоже +7 и тоже 10 цифр — покрывается этой же маской);
//    ведущая 8 автоматически заменяется на +7;
//  • любой другой ввод (другой код страны, например +49) → свободная
//    международная маска +<до 15 цифр> (E.164), без форматирования скобками.
//
// Синхронизация с Alpine x-model="form.phone" — через нативный input-event
// на каждое принятое значение (IMask сам обрабатывает paste и автозаполнение).

const RU_MASK = '+{7} (000) 000-00-00'
const INTL_MASK = '+000000000000000'

export default () => ({
    init() {
        const mask = IMask(this.$el, {
            mask: [{ mask: RU_MASK }, { mask: INTL_MASK }],

            // На пустом поле ведущую 8 трактуем как код страны 7
            // (работает и при наборе одной цифры, и при вставке «8900…»).
            prepare: (appended, masked) => {
                const hasDigits = masked.value.replace(/\D/g, '') !== ''
                if (!hasDigits && appended.startsWith('8')) {
                    return '7' + appended.slice(1)
                }
                return appended
            },

            // Выбор маски: 7/8 в начале → российская, иначе международная.
            dispatch: (appended, dynamicMasked) => {
                const digits = (dynamicMasked.value + appended).replace(/\D/g, '')
                const first = digits[0]
                const useRu = digits === '' || first === '7' || first === '8'
                return dynamicMasked.compiledMasks[useRu ? 0 : 1]
            },
        })

        mask.on('accept', () => {
            this.$el.dispatchEvent(new Event('input', { bubbles: true }))
        })

        // Сброс формы (form.phone = '') очищает и маску.
        this.$watch('form.phone', (value) => {
            if (!value && mask.value) {
                mask.value = ''
            }
        })
    },
})
